import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_projects_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { billingContractLineId: number, billingContractId?: number }): 
  Promise<{ result: { Id?: number, BillingContractLineId?: number, Percentage?: number, ProjectId?: number, Project?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractLineId)) {
      $missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { billingContractLineId: number, billingContractId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingContractLineId?: number, Percentage?: number, ProjectId?: number, Project?: { Name?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractLineId)) {
      $missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { billingContractLineId: number, billingContractId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingContractLineId?: number, Percentage?: number, ProjectId?: number, Project?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingContractLineId)) {
      $missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      billingContractLineId: number, billingContractId?: number    }) {
        if(isNil($inParams.billingContractLineId)) {
          return true; 
        }
      return false;
    }
}
